/**
 * SHOP-1353: Ritual Finder promo buttons -> Alhena quiz.
 * Uses the Alhena widget already loaded by gleenAi.js. Does not set
 * document.gleenConfig or load the SDK.
 * Separate from ritual-finder.js, which is the Ritual Finder quiz pages.
 */
(function () {
  'use strict';

  if (window.__ritualFinderPromoInit) return;
  window.__ritualFinderPromoInit = true;

  var QUIZ_INSTANCE = 'ritual-finder';
  var HELP_MESSAGE = 'Can you help me find my skin type?';
  var WAIT_INTERVAL_MS = 250;
  var WAIT_MAX_MS = 10000;

  var pendingMessage = null;
  var waitTimer = null;

  function buildSkinTypeMessage(skinType) {
    return 'What products are recommended for ' + skinType.toLowerCase() + ' skin?';
  }

  function widgetReady() {
    return !!(window.gleenWidget && typeof window.gleenWidget.sendQuizMessage === 'function');
  }

  function send(message) {
    try {
      window.gleenWidget.sendQuizMessage(message, { instance: QUIZ_INSTANCE });
    } catch (error) {
      console.error('[ritual-finder-promo] sendQuizMessage failed:', error);
    }
  }

  function sendWhenReady(message) {
    if (widgetReady()) {
      send(message);
      return;
    }

    pendingMessage = message;
    if (waitTimer) return;

    var waited = 0;
    waitTimer = setInterval(function () {
      waited += WAIT_INTERVAL_MS;

      if (widgetReady()) {
        clearInterval(waitTimer);
        waitTimer = null;
        var message = pendingMessage;
        pendingMessage = null;
        send(message);
      } else if (waited >= WAIT_MAX_MS) {
        clearInterval(waitTimer);
        waitTimer = null;
        pendingMessage = null;
        console.warn('[ritual-finder-promo] Alhena widget did not load, message not sent.');
      }
    }, WAIT_INTERVAL_MS);
  }

  // Delegated listener: keeps working after AJAX re-renders (filters, pagination).
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var optionButton = target.closest('[data-ritual-finder-option]');
    if (optionButton) {
      var skinType = (optionButton.textContent || '').trim();
      if (skinType) sendWhenReady(buildSkinTypeMessage(skinType));
      return;
    }

    var helpButton = target.closest('[data-ritual-finder-help]');
    if (helpButton) sendWhenReady(HELP_MESSAGE);
  });
})();